import { useDispatchPageEvent } from '@/global/hooks'
import { EventName } from '@/global/utils/analytics-events/types/common'
import { HOME_URL } from '@/global/constants/routes'
import Image from 'next/image'
import {
  WHelper,
  WIcon,
  WParagraph,
  WTitle
} from '@alice-health/wonderland-react'
import { AppLink } from '@/global/components/AppLink'
import { FunctionComponent, useContext } from 'react'
import { SimulatorContext } from '@/modules/simulator/contexts'
import { strings } from './MECompanySuccess.helpers'

const MECompanySuccess: FunctionComponent = () => {
  useDispatchPageEvent({
    eventName: EventName.PAGE_VIEWED,
    pageTitle: 'Página de finalização de simulação de 1-5 funcionários'
  })

  const { simulation } = useContext(SimulatorContext)

  const isReaccess = simulation.isReaccessingMESimulation

  const name = simulation.answers.responsibleName || ''

  return (
    <div className='py-gl-spacing-06 px-gl-spacing-08 h-full flex flex-col justify-center items-center'>
      <Image
        width={300}
        height={300}
        src='/images/simulator/contact-linked.png'
        alt='Ilustração de dois ícones de pessoas conectadas via WhatsApp'
      />

      <div className='flex flex-col justify-between gap-4 mt-7 text-center items-center'>
        <WTitle
          className='w-64'
          size='small'
          mode='primary'
          variant='heavy'
        >
          {isReaccess
            ? strings.reaccessedSimulation.title
            : strings.title(name)}
        </WTitle>

        <WParagraph
          size='large'
          className='w-72'
        >
          {isReaccess
            ? strings.reaccessedSimulation.description
            : strings.description}
        </WParagraph>

        {!isReaccess ? (
          <div className='flex items-center justify-around gap-gl-spacing-02'>
            <div className='text-gl-color-shades-magenta-70'>
              <WIcon
                icon='icCrono'
                size='medium'
                color='content-active'
              />
            </div>

            <WHelper className='text-gl-font-size-md text-gl-color-shades-magenta-70'>
              {strings.note}
            </WHelper>
          </div>
        ) : null}
      </div>

      <AppLink
        className='mt-gl-spacing-10'
        as='button'
        href={HOME_URL}
        variant='primary'
      >
        {strings.linkLabel}
      </AppLink>
    </div>
  )
}

export { MECompanySuccess }
